@if (
    (amountFormGroup?.controls?.userAmount?.dirty || amountFormGroup?.controls?.userAmount?.touched) &&
    amountFormGroup?.controls?.userAmount?.hasError('selfSetLimit')
) {
    <div class="clear-both">
        @if (ccDepositLimitCheckEnabled && showCCDepositLimitCheckMsg) {
            <show-message id="creditcard_deposit_limit_message2" [type]="messageType.ERROR">
                <div error>
                    <p>
                        {{
                            'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limit.message2'
                                | translate
                                    : {
                                          annualLimit: 100 | vnCurrency: currencyUSD,
                                          avlAmount: +ccCurrentDepositLimit | vnCurrency: currencyUSD,
                                      }
                        }}
                    </p>
                    <p>
                        <a (click)="updateCcdLimit()" id="updateccdlimit" class="fr text-bold">
                            {{ 'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limits.update' | translate }}
                        </a>
                    </p>
                </div>
            </show-message>
        }
        @if (maxDepositLimit > '0' && !showPrepaidCardsExceedsMessage) {
            <show-message id="creditcard_deposit_max_limit_1" [type]="messageType.ERROR">
                <div error>
                    @if (maxDepositLimit > '0') {
                        @if (selfLimits?.type?.includes('purchase_limit')) {
                            <p
                                [vnDynamicHtml]="
                                    'PARTY.CASHIER.web.limits.purchaselimits.exceeded1.msg1'
                                        | translate: { frequency: limitPeriod, instrument: instrumentName }
                                "></p>
                        } @else {
                            <p>{{ 'PARTY.CASHIER.web.limits.exceeded1.' + limitPeriod?.toLowerCase() | translate }}</p>
                        }
                        @if (minDepositLimitCheck) {
                            <p>
                                {{
                                    'PARTY.CASHIER.web.limits.exceeded2'
                                        | translate
                                            : {
                                                  remainingLimit:
                                                      maxDepositLimit | vnCurrency: selectedOption?.paymentMethodInfo?.maxDepositLimit?.currencyCode,
                                              }
                                }}
                            </p>
                        }
                        @if (minDepositLimitCheck) {
                            <a class="fr text-bold" (click)="changeAmount(maxDepositLimit)" id="updateAmount">{{
                                'PARTY.CASHIER.web.limits.exceeded3' | translate
                            }}</a>
                        }
                    }
                </div>
            </show-message>
        }
        @if (maxDepositLimit == '0') {
            <show-message id="creditcard_deposit_max_limit" [type]="messageType.ERROR">
                <div error>
                    @if (selfLimits.type.includes('rg_limit')) {
                        <p>
                            <span>{{ 'PARTY.CASHIER.web.limits.rg.exceeded.' + limitPeriod?.toLowerCase() | translate }}</span>
                            @if (country == 'BE') {
                                <span
                                    [vnDynamicHtml]="
                                        'PARTY.CASHIER.web.limits.rg.review'
                                            | translate
                                                : {
                                                      increaseLimitUrl: depositInfo.increaseLimitUrl,
                                                  }
                                    ">
                                </span>
                            } @else {
                                <span>{{ 'PARTY.CASHIER.web.limits.rg.non_be.review' | translate }}</span>
                            }
                        </p>
                    }
                    @if (selfLimits.type.includes('purchase_limit') || selfLimits.type.includes('overall_deposit_limit')) {
                        @if (selfLimits.type.includes('purchase_limit')) {
                            <p
                                [vnDynamicHtml]="
                                    'PARTY.CASHIER.web.limits.purchaselimits.exceeded1.msg2'
                                        | translate: { frequency: limitPeriod, instrument: instrumentName }
                                "></p>
                        } @else {
                            <span>{{ 'PARTY.CASHIER.web.limits.purchaselimits.exceeded' | translate }} </span>
                            <span
                                class="transaction-link"
                                style="cursor: pointer; text-decoration: underline"
                                (click)="gotoTransactionHistory()"
                                id="gotoTransactionHistory"
                                [vnDynamicHtml]="'PARTY.CASHIER.web.limits.purchaselimits.paymenthistory' | translate"></span>
                        }
                    }
                </div>
            </show-message>
        }
    </div>
} @else if (
    (amountFormGroup?.controls?.userAmount?.dirty || amountFormGroup?.controls?.userAmount?.touched) &&
    amountFormGroup?.controls?.userAmount?.hasError('spainRekycLimit') &&
    spainRekycLimitTemplate
) {
    <show-message [type]="messageType.WARNING">
        <div warning>
            <p class="text-bold">
                {{
                    'PARTY.CASHIER.web.deposit.rekyc.tobeExceeded.limit.' + spainRekycLimitTemplate + '.minAmount.header'
                        | translate
                            : {
                                  remainingLimit:
                                      userDataService?.userData?.configParams?.rekycRemainingLimit
                                      | vnCurrency: selectedOption?.paymentMethodInfo?.maxDepositLimit?.currencyCode : '1.0',
                              }
                }}
            </p>
            <p>{{ 'PARTY.CASHIER.web.deposit.rekyc.tobeExceeded.limit.' + spainRekycLimitTemplate + '.minAmount.text' | translate }}</p>
            <div class="fr mt-2">
                @if (spainRekycLimitTemplate == 'available') {
                    <a
                        class="text-bold text-decoration-none mr-3 text-uppercase"
                        (click)="changeAmount(userDataService?.userData?.configParams?.rekycRemainingLimit)"
                        >{{ 'PARTY.CASHIER.web.deposit.rekyc.updateAmount' | translate }}</a
                    >
                }
                <a
                    (click)="uploadMyId()"
                    class="text-bold text-decoration-none text-uppercase"
                    href="{{ userDataService?.userData?.configParams?.rekycUrl }}"
                    target="_top"
                    >{{ 'PARTY.CASHIER.web.deposit.rekyc.exhausted.limit.uploadMyId.link' | translate }}</a
                >
            </div>
        </div>
    </show-message>
} @else if (
    (amountFormGroup?.controls?.userAmount?.dirty || amountFormGroup?.controls?.userAmount?.touched) &&
    amountFormGroup?.controls?.userAmount?.hasError('spainOdInlineVal')
) {
    <show-message [type]="messageType.WARNING">
        <div warning>
            <span>
                <strong
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.occu.msg2'
                            | translate
                                : {
                                      amount: behaviorData?.userODetails?.allowedAmt | vnCurrency: currencyEUR,
                                  }
                    "></strong>
                <p>{{ 'PARTY.CASHIER.web.deposit.occu.msg3' | translate }}</p>
                <div class="mt-2 fr text-bold customfont">
                    <a class="text-decoration-none mr-2" (click)="updateAmount()" id="updateAmount">{{
                        'PARTY.CASHIER.web.deposit.occu.button3' | translate
                    }}</a>
                    <a class="text-decoration-none" target="_top" (click)="shareOD()" href="{{ behaviorData?.userODetails?.urlInfo?.url }}">{{
                        'PARTY.CASHIER.web.deposit.occu.button4' | translate
                    }}</a>
                </div>
            </span>
        </div>
    </show-message>
}
@if (enablePrepaidcardRestrictions && showPrepaidCardsExceedsMessage) {
    <show-message id="enable_prepaidcard_restrictions" [type]="messageType.ERROR">
        <div error>
            <p>
                {{
                    'PARTY.CASHIER.web.deposit.prepaidCard.deposits.entered.exceeds.cumulativeAmount'
                        | translate
                            : {
                                  maxLimit: rollingWeekMaxAmount | vnCurrency: selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode,
                                  remainingAmount:
                                      rollingWeekRemainingAmount | vnCurrency: selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode,
                              }
                }}
            </p>
            <a class="fr text-bold" (click)="changeAmount(rollingWeekRemainingAmount)">
                {{ 'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limits.update' | translate }}
            </a>
        </div>
    </show-message>
}
